import { checkoutDeliveryDateVar } from 'app/apollo/reaction';

import DELIVERY_DATES_QUERY from 'app/graphql/network/checkout/deliveryDatesQuery';

import {
    CREATE_INVOICE,
} from 'app/graphql/network/checkout/checkoutMutations';

import { getDigitsFromPhone } from 'app/utils/phone';

import { getUTMParams } from 'app/utils/utmParams';
import { resolveLocation } from 'app/containers/LocationProvider';
import { checkDateIsInSamePeriod } from 'app/utils/checkDateIsInSamePeriod';
import { mealprepDishes } from '../../../pages/_disabled/mealprep/dishesData';
import {
    mapDates,
    mapIntervals,
    getAddressValidationState,
    getInvoiceTags,
} from './checkout-utils';
import {
    LP_GET_FULL_DELIVERY_INTERVALS_DATA,
} from './requests/checkout-store.query';

export const initialCheckoutState = {

};

export function createInitialCheckoutState({ config, period }) {
    const {
        defaultBeltwayHit,
    } = config;

    const beltwayHit = defaultBeltwayHit || 'inside_mkad';

    return {
        region_name: '',
        period: period || '',
        deliveryDates: [],
        deliveryIntervals: [],
        date: '',
        interval: {
            index: 0,
            beltwayHit,
        },
        intervalsLoading: true,

        phone: {
            value: '',
            validation: {
                hasError: false,
                errorText: '',
            },
            isErroVisible: false,
        },

        promocode: {
            value: '',
            isLoading: false,
        },
        address: {
            value: '',
            data: {},
            validation: {
                hasError: true,
                errorText: '',
            },
        },
        entrance: '',
        floor: '',
        flat: '',
        addressComment: '',

        invoice: {
            loading: false,
            createdInvoice: null,
        },
    };
}


export function checkoutReducer(state, action) {
    const { type, payload } = action;
    switch (type) {
        case 'SET_DELIVERY_DATES':
            return {
                ...state,
                deliveryDates: payload.deliveryDates,
            };
        case 'FILTER_NY_DELIVERY_DATES':
            return {
                ...state,
                deliveryDates: state.deliveryDates.filter((date) => {
                    if (date.date === '2025-12-29') {
                        return {
                            ...date,
                            enabled: false,
                        };
                    }
                    return date;
                }),
            };
        case 'SET_DELIVRY_DATE':
            return {
                ...state,
                deliveryIntervals: payload.deliveryIntervals,
                date: payload.date,
                interval: payload.interval,
                region_name: payload.region_name,
                intervalsLoading: false,
            };
        case 'SET_DELIVRY_INTERVAL':
            return {
                ...state,
                interval: payload.interval,
            };

        case 'CHANGE_ADDRESS':
            return {
                ...state,
                address: {
                    ...state.address,
                    validation: payload.address.validation,
                },
            };

        case 'SELECT_ADDRESS':
            return {
                ...state,
                address: payload.address,
                interval: payload.interval,
            };

        case 'CHANGE_PHONE': {
            return {
                ...state,
                phone: payload.phone,
            };
        }

        case 'CHANGE_PROMOCODE': {
            const promocodeState = state.promocode;
            return {
                ...state,
                promocode: {
                    ...promocodeState,
                    value: payload.promocode,
                },
            };
        }

        case 'LOADING_PROMOCODE': {
            const promocodeState = state.promocode;
            return {
                ...state,
                promocode: {
                    ...promocodeState,
                    isLoading: payload.isLoading,
                },
            };
        }
        case 'CHANGE_FLAT': {
            return {
                ...state,
                flat: payload.flat,
            };
        }
        case 'CHANGE_ENTRANCE': {
            return {
                ...state,
                entrance: payload.entrance,
            };
        }
        case 'CREATE_INVOICE_STARTED': {
            return {
                ...state,
                invoice: {
                    loading: true,
                },
            };
        }
        case 'CREATE_INVOICE_FULLFILLED': {
            return {
                ...state,
                invoice: {
                    loading: false,
                    createdInvoice: payload.invoice,
                },
            };
        }

        default: return state;
    }
}

/* Actions */

export function createActions({ config, filtersContext }) {
    async function selectDateAction({
        state,
        dispatch,
        client,
        options,
        nextBeltwayHit,
        context,
    }) {
        try {
            const {
                nextDate,
                nextAddress,
                period,
                ignorePeriodForDeliveryDates,
            } = options;

            if (!nextDate) {
                return;
            }

            checkoutDeliveryDateVar(nextDate);

            const {
                interval: { index, beltwayHit },
                address: stateAddress,
            } = state;

            const finalBeltwayHit = nextBeltwayHit || beltwayHit;

            const address = nextAddress || stateAddress;

            const {
                data: { deliveryIntervals },
            } = await client.query({
                query: LP_GET_FULL_DELIVERY_INTERVALS_DATA,
                variables: { date: nextDate },
                fetchPolicy: 'network-only',
            });

            const { region_name } = deliveryIntervals;

            const mutationsPeriod = ignorePeriodForDeliveryDates ? period : nextDate;

            if (context?.refetchBasket) {
                await context?.refetchBasket({
                    period: mutationsPeriod,
                    delivery_date: mutationsPeriod,
                });
            }

            const mappedIntervals = mapIntervals(deliveryIntervals?.deliveryTimesList, nextDate, address, config);
            const matchedInterval = mappedIntervals[index];

            const nextIntervalIndex = matchedInterval && matchedInterval.enabled
                ? index
                : mappedIntervals.findIndex((i) => i.enabled);

            const { visiblePeriods } = filtersContext;
            const periodOfCurrentDate = visiblePeriods?.find((p) => checkDateIsInSamePeriod(nextDate, p.start));

            if (!ignorePeriodForDeliveryDates && periodOfCurrentDate?.start !== period) {
                filtersContext.changePeriod(periodOfCurrentDate?.start);
            }

            if (!mappedIntervals?.length) return;

            dispatch({
                type: 'SET_DELIVRY_DATE',
                payload: {
                    region_name,
                    deliveryIntervals: mappedIntervals,
                    date: nextDate,
                    interval: {
                        index: nextIntervalIndex,
                        beltwayHit: finalBeltwayHit,
                    },
                    intervalsLoading: false,
                },
            });
        } catch (err) {
            console.log(err);
        }
    }

    async function changeFlatAction({
        state,
        dispatch,
        options: { flat, period: optionsPeriod },
        context,
    }) {
        dispatch({
            type: 'CHANGE_FLAT',
            payload: {
                flat,
            },
        });

        if (context) {
            const { updateShipping } = context;
            const {
                period: statePeriod,
                address,
                entrance: stateEntrance,
                floor: stateFloor,
                addressComment: stateAddressComment,
            } = state;

            const variables = {
                period: optionsPeriod || statePeriod,
                address: {
                    address: address.value,
                    entrance: stateEntrance,
                    flat,
                    floor: stateFloor,
                    comment: stateAddressComment,
                },
            };
            await updateShipping({ variables });
        }
    }

    async function changeEntranceAction({
        state,
        dispatch,
        options: { entrance, period: optionsPeriod },
        context,
    }) {
        dispatch({
            type: 'CHANGE_ENTRANCE',
            payload: { entrance },
        });

        if (context) {
            const { updateShipping } = context;
            const {
                period: statePeriod,
                address,
                floor: stateFloor,
                flat: stateFlat,
                addressComment: stateAddressComment,
            } = state;

            const variables = {
                period: optionsPeriod || statePeriod,
                address: {
                    address: address.value,
                    entrance,
                    flat: stateFlat,
                    floor: stateFloor,
                    comment: stateAddressComment,
                },
            };
            await updateShipping({ variables });
        }
    }

    function selectTimeIntervalAction({
        dispatch,
        options,
    }) {
        const { interval } = options;
        dispatch({
            type: 'SET_DELIVRY_INTERVAL',
            payload: {
                interval,
            },
        });
    }

    async function initializeDatesAction({
        state,
        dispatch,
        client,
        options,
        nextBeltwayHit,
        context,
    }) {
        const {
            period,
            trialScenario,
            nextAddress,
            ignorePeriodForDeliveryDates,
            basketDishesIds,
            locationKey,
        } = options;

        await client.query({
            query: LP_GET_FULL_DELIVERY_INTERVALS_DATA,
            fetchPolicy: 'network-only',
        });

        return client.query({
            query: DELIVERY_DATES_QUERY,
            variables: {
                period,
                ignore_period: ignorePeriodForDeliveryDates,
                trial_scenario: trialScenario,
            },
            fetchPolicy: 'network-only',
        }).then(async ({ data }) => {
            const isMSKUser = ['MSK', 'TUL', 'YAR', 'VLA', 'RYA', 'KLU', 'TVE'].includes(locationKey);
            const prevSelectedDate = state.date;
            const dates = data ? data.deliveryDates.availableDates : [];

            const deliveryDates = mapDates(
                dates, period, config, basketDishesIds, filtersContext,
            )
                .map((e) => ({ ...e, enabled: true }));

            const hasMealprepDishesInBasket = basketDishesIds.some((id) => mealprepDishes.includes(id));
            const mskDates = [
                '2026-01-23', '2026-01-30',
                '2026-02-06', '2026-02-13', '2026-02-20', '2026-02-27',
            ];
            const restDates = [
                '2026-01-24', '2026-01-31',
                '2026-02-07', '2026-02-14', '2026-02-21', '2026-02-28',
            ];

            const filteredDates = hasMealprepDishesInBasket ? deliveryDates.filter((d) => {
                if (isMSKUser) {
                    return mskDates.includes(d.date);
                }
                return restDates.includes(d.date);
            }) : deliveryDates;

            const isPrevDateEnabled = filteredDates.find((d) => d.date === prevSelectedDate && d.enabled);

            const firstEnabledDate = deliveryDates.find((d) => d.enabled);

            /* eslint-disable no-nested-ternary */
            const defaultSelectedDate = isPrevDateEnabled
                ? prevSelectedDate
                : (firstEnabledDate ? firstEnabledDate.date : null);
            /* eslint-enable no-nested-ternary */

            console.log({
                deliveryDates,
                isPrevDateEnabled,
                prevSelectedDate,
                firstEnabledDate,
                defaultSelectedDate,
            });

            dispatch({
                type: 'SET_DELIVERY_DATES',
                payload: {
                    deliveryDates: filteredDates,
                },
            });

            await selectDateAction({
                state,
                dispatch,
                client,
                options: {
                    nextDate: defaultSelectedDate,
                    nextAddress,
                    ignorePeriodForDeliveryDates,
                    period,
                },
                nextBeltwayHit,
                context,
            });

            return defaultSelectedDate;
        }).catch((e) => console.log(e));
    }

    async function selectAddressAction({
        state,
        dispatch,
        client,
        options,
        context,
    }) {
        const {
            flat: stateFlat,
            entrance: stateEntrance,
            floor: stateFloor,
            addressComment: stateAddressComment,
        } = state;

        const {
            address,
            period,
            trialScenario,
            flat: optionFlat,
            entrance: optionEntrance,
            ignorePeriodForDeliveryDates,
            basketDishesIds,
            isNYPage,
        } = options;

        const validation = getAddressValidationState(address);

        if (!validation.hasError) {
            const {
                updateShipping,
                onLocationChange,
            } = context;

            const variables = {
                period,
                address: {
                    address: address.value,
                    entrance: optionEntrance || stateEntrance,
                    flat: optionFlat || stateFlat,
                    floor: stateFloor,
                    comment: stateAddressComment,
                },
            };

            if (updateShipping) {
                const { data: { shipping: { address: { city, country_subdivision } } } } = await updateShipping({ variables });
                const locationKey = resolveLocation(country_subdivision);

                if (onLocationChange) {
                    onLocationChange(locationKey);
                }

                initializeDatesAction({
                    state,
                    dispatch,
                    client,
                    options: {
                        period,
                        trialScenario,
                        nextAddress: address,
                        ignorePeriodForDeliveryDates,
                        basketDishesIds,
                        locationKey,
                        isNYPage,
                    },
                    nextBeltwayHit: 'inside_mkad',
                    context,
                });
            }
        }

        dispatch({
            type: 'SELECT_ADDRESS',
            payload: {
                address: {
                    value: address.value,
                    data: address.data,
                    validation,
                },
                interval: {
                    index: 0,
                    beltwayHit: 'inside_mkad',
                },
            },
        });

        if (!validation.hasError) {
            const {
                refetchBasket,
            } = context;

            if (refetchBasket) {
                await refetchBasket();
            }
        }
    }

    function changePromocodeAction({
        dispatch,
        options,
    }) {
        const { promocode } = options;

        dispatch({
            type: 'CHANGE_PROMOCODE',
            payload: {
                promocode,
            },
        });
    }

    function changeLoadingPromocodeAction({
        dispatch,
        options,
    }) {
        const { isLoading } = options;

        dispatch({
            type: 'LOADING_PROMOCODE',
            payload: {
                isLoading,
            },
        });
    }

    function changePhoneAction({
        state,
        dispatch,
        options,
    }) {
        const {
            phone = state.phone.value,
            isErroVisible = false,
        } = options;

        const hasError = phone?.length < 11;
        const errorText = hasError ? 'Введите номер телефона' : '';

        dispatch({
            type: 'CHANGE_PHONE',
            payload: {
                phone: {
                    value: phone,
                    validation: {
                        hasError,
                        errorText,
                    },
                    isErroVisible,
                },
            },
        });
    }

    function changeAddressAction({
        dispatch,
    }) {
        dispatch({
            type: 'CHANGE_ADDRESS',
            payload: {
                address: {
                    validation: {
                        hasError: true,
                        errorText: '',
                    },
                },
            },
        });
    }

    async function createInvoice({
        state,
        dispatch,
        client,
        options,
    }) {
        const {
            period,
            basketDishesIds,
            paymentMethod,
            printed_recipes,
        } = options;

        const pm = paymentMethod || config.paymentMethod || 'online';

        const {
            deliveryIntervals,
            interval,
            address,
            phone,
            date,
            flat,
            entrance,
            region_name,
        } = state;

        const deliveryAddress = {
            city: address.data.city,
            street: address.value,
            house: address.data.house,
            flat,
            entrance,
        };

        if (state.invoice.createdInvoice) {
            return state.invoice.createdInvoice;
        }

        const deliveryTime = deliveryIntervals[interval.index];

        const utmParams = getUTMParams();

        const variables = {
            phone: getDigitsFromPhone(phone.value ?? ''),
            period,
            tags: getInvoiceTags(basketDishesIds, config),
            delivery_date: date,
            delivery_time: {
                hour_from: deliveryTime.hour_from,
                hour_to: deliveryTime.minute_to === 59 ? deliveryTime.hour_to + 1 : deliveryTime.hour_to,
            },
            delivery_address: deliveryAddress,
            payment_method: pm,
            utm: utmParams,
            delivery_region_name: region_name,
            printed_recipes,
            with_customization: false,
        };

        dispatch({ type: 'CREATE_INVOICE_STARTED' });

        try {
            const resp = await client.mutate({
                mutation: CREATE_INVOICE,
                variables,
            });
            const invoice = resp.data.createInvoice;

            dispatch({
                type: 'CREATE_INVOICE_FULLFILLED',
                payload: {
                    invoice,
                },
            });

            localStorage.removeItem('promocodeFromBasketToSet');

            return invoice;
        } catch (e) {
            return null;
        }
    }

    return {
        selectDateAction,
        selectTimeIntervalAction,
        initializeDatesAction,
        changePromocodeAction,
        changeLoadingPromocodeAction,
        changePhoneAction,
        changeFlatAction,
        changeEntranceAction,
        changeAddressAction,
        selectAddressAction,
        createInvoice,
    };
}
